var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 12.1429L9.2 16L19 7","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Check.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","color":"currentColor"};

module.exports = Check;

Check.default = Check;
